import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  drawerContainer: {
    maxWidth: 450,
    padding: "24px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "@media (max-width: 550px)": {
      minWidth: "100vw",
      maxWidth: "100%"
    }
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px"
  },
  title: {
    fontWeight: 700,
    fontSize: "18px"
  },
  closeButton: {
    color: "black",
    backgroundColor: "#F3F4F6",
    borderRadius: "50%",
    padding: "4px"
  },
  card: {
    border: "1px solid #E5E7EB",
    borderRadius: "12px",
    padding: "10px",
    marginBottom: "16px"
  },
  cardTitle: {
    fontSize: "14px",
    fontWeight: 600,
    marginBottom: "8px"
  },
  flexColumn: {
    background: "#FAFAFA",
    padding: "10px"
  },
  gridRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "12px",
    alignItems: "center",
    gap: "3.5rem",
    "@media (max-width: 550px)": {
      gap: "1rem"
    }
  },
  label: {
    color: "#6B7280",
    fontSize: "13px"
  },
  value: {
    fontSize: "13px",
    fontWeight: 500
  },
  statusBadge: {
    backgroundColor: "#DCFCE7",
    color: "#166534",
    padding: "4px 8px",
    borderRadius: "6px",
    fontSize: "12px",
    fontWeight: 600
  },
  textField: {
    marginBottom: "16px",
    backgroundColor: "#F9FAFB"
  },
  updateButton: {
    backgroundColor: theme.palette.primary.main,
    textTransform: "none",
    fontWeight: 600
  },
  actionsCard: {
    border: "1px solid #E5E7EB",
    borderRadius: "12px",
    padding: "10px",
    backgroundColor: "#fff"
  },
  inputLabel: {
    fontSize: "13px",
    color: "#4B5563",
    marginBottom: "8px",
    display: "block"
  },
  emailRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "24px"
  },
  emailInputWrapper: {
    flex: 1,
    position: "relative"
  },
  emailInput: {
    width: "100%",
    padding: "12px 16px",
    backgroundColor: "#F9FAFB",
    border: "none",
    borderRadius: "8px",
    color: "#374151",
    fontSize: "13px",
    outline: "none"
  },
  saveButtonWrapper: {
    width: "auto"
  },
  buttonGroup: {
    display: "flex",
    gap: "16px"
  },
  manualVerifyBtn: {
    flex: 1,
    padding: "10px",
    backgroundColor: "#FFFFFF",
    border: "1px solid #E5E7EB",
    borderRadius: "8px",
    color: "#374151",
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "#F9FAFB"
    }
  },
  markInvalidBtn: {
    flex: 1,
    padding: "10px",
    backgroundColor: "#FFFFFF",
    border: "1px solid #FCA5A5",
    borderRadius: "8px",
    color: "#DC2626",
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "#FEF2F2"
    }
  },
  dialogPaper: {
    borderRadius: "6px !important",
    padding: "16px",
    minWidth: "400px",
    maxWidth: "450px"
  },
  dialogTitle: {
    fontSize: "18px",
    fontWeight: "700",
    paddingTop: 0,
    color: "#111827",
    marginBottom: "16px",
    borderBottom: "1px solid #E5E7EB"
  },
  dialogContentText: {
    fontSize: "13px",
    color: "#4B5563",
    marginBottom: "32px",
    lineHeight: "1.6",
    padding: "14px 0"
  },
  dialogActions: {
    display: "flex",
    gap: "16px",
    padding: 0,
    justifyContent: "space-between"
  },
  modalBtnCancel: {
    flex: 1,
    padding: "10px 0",
    border: "1px solid #D1D5DB",
    borderRadius: "8px",
    backgroundColor: "#fff",
    color: "#374151",
    fontSize: "14px",
    fontWeight: "500",
    textTransform: "none",
    fontFamily: "Trip Sans",
    cursor: "pointer",
    transition: "0.2s",
    "&:hover": { backgroundColor: "#F9FAFB" }
  },
  modalBtnConfirm: {
    flex: 1,
    padding: "10px 0",
    border: "1px solid #2563EB",
    borderRadius: "8px",
    backgroundColor: "#fff",
    color: "#2563EB",
    fontSize: "14px",
    fontWeight: "500",
    textTransform: "none",
    fontFamily: "Trip Sans",
    cursor: "pointer",
    transition: "0.2s",
    "&:hover": { backgroundColor: "#EFF6FF" }
  },
  modalBtnInvalid: {
    flex: 1,
    padding: "10px 0",
    border: "1px solid #FCA5A5",
    borderRadius: "8px",
    backgroundColor: "#fff",
    color: "#DC2626",
    fontSize: "14px",
    fontWeight: "500",
    textTransform: "none",
    fontFamily: "Trip Sans",
    cursor: "pointer",
    transition: "0.2s",
    "&:hover": { backgroundColor: "#EFF6FF" }
  }
}));
